export const getInstructionLifecycleChipProps = (lifecycleState) => {
    const normalizedState = (lifecycleState || '').toUpperCase();

    if (normalizedState === 'READY') {
        return {
            label: 'READY',
            color: 'success',
            variant: 'outlined',
            sx: {
                backgroundColor: 'rgba(46, 125, 50, 0.08)',
                borderColor: 'rgba(46, 125, 50, 0.35)',
                color: '#1b5e20'
            }
        };
    }

    if (normalizedState === 'NEEDS_REGENERATION') {
        return { label: 'NEEDS_REGENERATION', color: 'error' };
    }

    return { label: 'DRAFT', color: 'warning' };
};
